import React from 'react';
import { motion } from 'framer-motion';
import './image.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const Images = () => {
  const snippetContainerRef = React.useRef(null);
  const [showScanning, setShowScanning] = React.useState(false);
  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="carve-media">
        <img
          src="https://images.unsplash.com/photo-1675627451054-99b6c760b6d2"
          alt="Sample"
        />
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <pre>
            <code>
              <>
                <span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-media</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;img</span>
              </>
              <>
                <span className='cln'> src="</span>
                <span className='cn'>...</span>
                <span className='cln'>"</span>
              </>
              <>
                <span className='cln'> alt="</span>
                <span className='cn'>image description</span>
                <span className='cln'>"</span>
              </>
              <>
                &nbsp;<span className='cn'>/&gt;</span>
              </>
              <br />
              <>
                <span className='cn'>&lt;/div&gt;</span>
              </>
            </code>

          </pre>
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
      <div className="carve_note">Note: Add your image URL in the src attribute,you can modify ".carve-media, .carve-media img" css as per your requirement.
      </div>
    </motion.div>
  );
};

const ImageCard = () => {
  return (
    <Card CardTitle="Image" CardBody={<Images />} />
  );
};

export default ImageCard;
